import { css, html, PropertyValues} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { VoyageShipWeatherExpectationPlayer } from '../../voyage-ship-weather-expectation-player/src/voyage-ship-weather-expectation-player';
import { CurrentLeg, PerfDataSetName, VesselPerformanceModel } from '../../../src/models/vessel-performance-model'

@customElement('vessel-performance-leg-by-leg')
export class VesselPerformanceLegByLeg extends VoyageShipWeatherExpectationPlayer {

    @property({type: Object}) data: Map<string, CurrentLeg> = new Map();

    constructor() {
        super();
        this._updatePerformance = this._updatePerformance.bind(this);
    }

    static get styles() {
        return css`
            .legendContainer {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                background-color: var(--neutrals-grey-10, white);
                height: 41px;
                width: 293px;
            }

            .legendContainer[hidden] {
                display: none;
            }

            .legend {
                display: flex;
                align-items: center;
                font-family: MaerskText;
                font-size: 12px;
                color: var(--neutrals-grey-03, black);
                margin-right: 10px;
                margin-left: 10px;
            }

            .container {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;
            }

            .leg-figures-container {
                width: 94px;
                height: 197px;
                background: var(--performance-viewer-graph-background-planning);
                margin-left: 10px;
            }

            .block {
                width: 100%;
                display: inline-block;
                color: var(--performance-viewer-dial-text-color);
                margin-top: 17px;
                margin-left: 10px;
            }

            .toptext {
                font-size: 14px;
                font-weight: normal;
                line-height: 12px;
            }

            .lowertext {
                font-size: 14px;
                line-height: 16px;
                font-weight: bold;
            }
        `;
    }

    private async _updatePerformance() {
        let newUiRoutesData = new Map();
        for (let index = 0; index < this._routesWithWeather.length; index++) {
            const legData = await VesselPerformanceModel!.getLegData(new Date(this._currentTime), <PerfDataSetName>this._routesWithWeather[index].id);
            newUiRoutesData.set(this._routesWithWeather[index].id, legData);
        }

        this.data = newUiRoutesData;
    }

    updated(changedProperties: PropertyValues) {
        if (!changedProperties.has("data")) {
            this._updatePerformance();
        }
    }

    render() {
        const filteredRoutes = this._routesWithWeather.filter(x => x.currentIndex !== -1);

        return html`
        ${filteredRoutes.map(routeWithWeather => html`
            <div class="container">
                <voyage-ship-wx
                    .heading=${this.headingAt(routeWithWeather.weatherByTimestamp[routeWithWeather.currentIndex].timestamp, routeWithWeather.route)}
                    .weatherElements=${routeWithWeather.weatherByTimestamp[routeWithWeather.currentIndex].weather}
                    routeName=${routeWithWeather.label} routeColor=${routeWithWeather.color}></voyage-ship-wx>
                <div class="leg-figures-container">
                    <div class="block">
                        <div class="toptext">ME Power</div>
                        <div class="lowertext">${this.data.get(routeWithWeather.id)?.MEPower.simulated ? this.data.get(routeWithWeather.id)!.MEPower.simulated!.value.toFixed(0) : '-'} KW</div>
                    </div>
                    <div class="block">
                        <div class="toptext">ME RPM</div>
                        <div class="lowertext">${this.data.get(routeWithWeather.id)?.RPM.simulated ? this.data.get(routeWithWeather.id)!.RPM.simulated!.value.toFixed(0) : '-'} RPM</div>
                    </div>
                    <div class="block">
                        <div class="toptext">SOG</div>
                        <div class="lowertext">${this.data.get(routeWithWeather.id)?.SOG.simulated ? this.data.get(routeWithWeather.id)!.SOG.simulated!.value.toFixed(1) : '-'} kn</div>
                    </div>
                    <div class="block">
                        <div class="toptext">STW</div>
                        <div class="lowertext">${this.data.get(routeWithWeather.id)?.STW?.simulated ? this.data.get(routeWithWeather.id)!.STW.simulated!.value.toFixed(1) : '-'} kn</div>
                    </div>
                </div>
            </div>
        `)}
        <div class="legendContainer" ?hidden=${filteredRoutes.length === 0}>
            <div class="legend">
                <canvas id="swellCanvas" height="16" width="18"></canvas>
                Swell
            </div>
            <div class="legend">
                <canvas id="waveCanvas" height="16" width="18"></canvas>
                Sea
            </div>
            <div class="legend">
                <canvas id="windCanvas" height="16" width="18"></canvas>
                Wind
            </div>
            <div class="legend">
                <canvas id="currentCanvas" height="16" width="18"></canvas>
                Current
            </div>
        </div>
        `;
    }
}
